export default function() {

	//地図の表示
	var mapPosition = {lat: 30, lng: 139.584674};
	var markerPosition = {lat: 35.705132, lng: 139.584674};
	var map = new google.maps.Map(document.getElementById('map'), {
		center: mapPosition,
		zoom: 15,
		mapTypeControl: false,
		fullscreenControl: false,
		streetViewControl: false,
		styles: [
			{
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			}
		]
	});

	//マーカーの表示
	var markerOptions = {
    map: map,
    position: markerPosition,
  };
  var marker = new google.maps.Marker(markerOptions);

	// 吹き出しの追加
	var infoWindow = new google.maps.InfoWindow({
    content: '<div class="map_fkds">生活教育<br />こどもと幼児園</div>' // 吹き出しに表示する内容
  });

	// 吹き出しの表示
	infoWindow.open(map, marker);

  markerEvent(); // マーカーにクリックイベントを追加

	function markerEvent() {
    marker.addListener('click', function() { // マーカーをクリックしたとき
	    infoWindow.open(map, marker); // 吹き出しの表示
    });
  };

}
